import { AuthTypes } from './auth.types';

let idp: Promise<AuthTypes.Idp> | null = null;

/**
 * Cognito, unless the app is running against mocks — then an offline stand-in. The flag
 * is a build-time constant, so the branch not taken is dropped from the bundle: a build
 * with mocks off contains no mock IDP and no mock token.
 */
export const getIdp = (): Promise<AuthTypes.Idp> =>
  (idp ??=
    import.meta.env.VITE_ENABLE_MOCKS === 'true'
      ? import('mocks/idp').then(({ mockIdp }) => mockIdp)
      : import('./cognito').then(({ cognitoIdp }) => cognitoIdp));
